import { TitleBlockWrapper, TitleDescription } from '@anm/components/TitleBlock';
import { CheckboxContainer } from '@anm/components/form/Checkbox';
import Alert from '@anm/components/notification/Alert';
import { flexCenter, flexColumn, flexRow, media, truncate } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

import { DeleteFolderRowProps } from './types';

export const Row = styled.label`
  ${flexRow};
  width: inherit;
  max-width: 100%;
  cursor: pointer;
  align-items: center;
  display: inline-flex;
  justify-content: space-between;
  padding-left: 14px;
  margin-bottom: 6px;
  padding-right: 30px;
  & > div:last-child {
    margin-left: 10px;
  }
  h3,
  span {
    ${truncate('254px')};
  }
`;

const mobileWrapper = media.phone`
  width: auto;

  ${Row} {
    width: 100%;
  }

  h3, span {
    width: auto;
  }
`;

export const ContentWrapper = styled.div`
  ${flexColumn};
  width: 410px;
  max-width: 100vw;
  padding-top: 17px;
  padding-bottom: 22px;
  ${CheckboxContainer} {
    margin-top: 2px;
  }
  & > ${TitleBlockWrapper} {
    ${flexColumn};
    ${flexCenter};
    h1,
    h2,
    h3,
    h4,
    h5 {
      font-size: 24px;
      line-height: 32px;
      margin-bottom: 12px;
    }
    ${TitleDescription} {
      hyphens: auto;
      font-size: 16px;
      max-width: 400px;
      line-height: 24px;
      text-align: center;
      margin-bottom: 19px;
      word-break: break-word;
    }
  }

  ${mobileWrapper};
`;

export const ListWrapper = styled.div`
  margin-bottom: 19px;
`;

export const ButtonsContainer = styled.div`
  ${flexRow};
  ${flexCenter};
  & > button {
    max-width: 180px;
    &:first-child {
      margin-right: 10px;
    }
  }
`;

export const FolderRow = styled(Row)<Pick<DeleteFolderRowProps, 'isDisabled'>>`
  ${flexCenter};
  margin-bottom: 16px;
  span {
    width: 185px;
  }
  ${({ isDisabled }) =>
    isDisabled &&
    css`
      opacity: 0.5;
      cursor: default;
    `}
`;

export const DeleteRecordingInfo = styled.div`
  ${flexRow};
  span {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const AlertWrapper = styled(Alert)`
  font-size: 14px;
  margin-bottom: 24px;
  color: var(--gray_900);
  border: 1px solid var(--error);
  p {
    margin: 0;
    cursor: pointer;
    display: inline-block;
    text-decoration: underline;
  }
`;
